import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  root: {},
  progress: {
    display: "block",
    width: "100%",
    height: "1px",
    backgroundColor: theme.palette.primary.main,
  },
}));

export default useStyles;
